var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 138.81 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#ccc;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#e6e6e6;}.cls-6{fill:url(#linear-gradient-4);}.cls-22,.cls-7{fill:#fff;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12,.cls-13,.cls-14,.cls-15{fill:#f7714d;}.cls-13{opacity:0.7;}.cls-13,.cls-14,.cls-15,.cls-19,.cls-22{isolation:isolate;}.cls-14{opacity:0.5;}.cls-15{opacity:0.3;}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:#fafafa;}.cls-18{fill:#6c63ff;}.cls-19,.cls-22{opacity:0.2;}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:#f27c4e;}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 119.81,
    y1: 4242,
    x2: 119.81,
    y2: 4254.15,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 4392)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 19.23,
    x2: 19.23,
    y2: 4254.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 69.4,
    y1: 4252.48,
    x2: 69.4,
    y2: 4392,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 69.4,
    y1: 4275.53,
    x2: 69.4,
    y2: 4369.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 59.37,
    y1: 4284.49,
    x2: 59.37,
    y2: 4289.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 66.06,
    y1: 4284.49,
    x2: 66.06,
    y2: 4289.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 72.75,
    y1: 4284.49,
    x2: 72.75,
    y2: 4289.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 79.44,
    y1: 4284.49,
    x2: 79.44,
    y2: 4289.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 69.4,
    y1: 4302.6,
    x2: 69.4,
    y2: 4352.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 69.4,
    y1: 4310.26,
    x2: 69.4,
    y2: 4344.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 284.74,
    y1: 4247.32,
    x2: 284.74,
    y2: 4267.15,
    gradientTransform: "matrix(1, 0, 0, -1, -260.85, 4308)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 284.74,
    y1: 4209.81,
    x2: 284.74,
    y2: 4229.64,
    gradientTransform: "matrix(1, 0, 0, -1, -260.85, 4308)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.68,
    y: 137.85,
    width: 10.27,
    height: 12.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 114.91,
    y: 138.85,
    width: 9.8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.1,
    y: 137.85,
    width: 10.27,
    height: 12.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.33,
    y: 138.85,
    width: 9.8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 138.81,
    height: 139.52,
    rx: 3.04,
    ry: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.96,
    y: 0.72,
    width: 137.13,
    height: 137.13,
    rx: 3.04,
    ry: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 23.05,
    y: 22.82,
    width: 92.7,
    height: 93.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 111.51,
    cy: 57.71,
    rx: 5.26,
    ry: 2.87,
    transform: "translate(-11.07 30.53) rotate(-14.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 110.97,
    cy: 79.73,
    rx: 2.87,
    ry: 5.26,
    transform: "translate(-0.49 158.77) rotate(-71.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 115.6,
    cy: 69.35,
    rx: 5.26,
    ry: 2.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 23.77,
    y: 23.77,
    width: 91.26,
    height: 91.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 56.86,
    y: 102.25,
    width: 5.02,
    height: 5.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 63.55,
    y: 102.25,
    width: 5.02,
    height: 5.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 70.24,
    y: 102.25,
    width: 5.02,
    height: 5.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 76.93,
    y: 102.25,
    width: 5.02,
    height: 5.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 56.98,
    y: 102.49,
    width: 4.78,
    height: 4.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 63.67,
    y: 102.49,
    width: 4.78,
    height: 4.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 70.36,
    y: 102.49,
    width: 4.78,
    height: 4.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 77.05,
    y: 102.49,
    width: 4.78,
    height: 4.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 69.4,
    cy: 64.4,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 69.4,
    cy: 64.4,
    r: 23.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 77.18,
    y: 48.87,
    width: 5.58,
    height: 1.59,
    transform: "translate(-6.59 86.68) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 83.34,
    y: 72.18,
    width: 1.59,
    height: 5.58,
    transform: "translate(-25.53 100.89) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 56.05,
    y: 78.34,
    width: 5.58,
    height: 1.59,
    transform: "translate(-39.74 81.95) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 53.87,
    y: 51.06,
    width: 1.59,
    height: 5.58,
    transform: "translate(-20.79 67.74) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 77.16,
    y: 48.83,
    width: 5.58,
    height: 1.59,
    transform: "translate(-6.56 86.65) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 83.33,
    y: 72.13,
    width: 1.59,
    height: 5.58,
    transform: "translate(-25.5 100.86) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 56.04,
    y: 78.3,
    width: 5.58,
    height: 1.59,
    transform: "translate(-39.7 81.92) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 53.86,
    y: 51.01,
    width: 1.59,
    height: 5.58,
    transform: "translate(-20.76 67.71) rotate(-55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 69.4,
    cy: 64.41,
    r: 17.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 69.4,
    cy: 64.41,
    r: 16.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M56.06,66.6A16.33,16.33,0,0,1,80.52,52.41,16.33,16.33,0,1,0,61.06,78.35,16.28,16.28,0,0,1,56.06,66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M27.71,60.68H20.07V41.59a.74.74,0,0,1,.74-.74H27a.74.74,0,0,1,.74.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M26.93,98.19H20.85a.78.78,0,0,1-.78-.78v-19h7.65v19a.78.78,0,0,1-.78.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M21,41.09h5.87a.65.65,0,0,1,.65.65V60.2H20.31V41.75a.65.65,0,0,1,.64-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M20.31,78.6h7.16V97.5a.22.22,0,0,1-.22.22H20.53a.22.22,0,0,1-.22-.22V78.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.8,64.39H73.63V61.1h0a4.22,4.22,0,0,0-8.45,0h0v3.29H64a.47.47,0,0,0-.47.47v6.57a.47.47,0,0,0,.47.47H74.8a.47.47,0,0,0,.47-.47V64.86A.47.47,0,0,0,74.8,64.39Zm-8-3.29h0a2.58,2.58,0,0,1,5.16,0h0v3.29H66.82Zm3.47,8.24H68.52l.57-1.65a.94.94,0,1,1,.63,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxVault);
export default __webpack_public_path__ + "static/media/gfx-vault.014ab5db822754aa5c5210f336382b69.svg";
export { ForwardRef as ReactComponent };